import type {
  CareOptionKey,
  CareRecipient,
  UrgencyOption,
} from "../types/care-seeker";

const CARE_RECIPIENT_LABELS: Record<CareRecipient, string> = {
  me: "Myself",
  other: "Someone Else",
  parent: "Parent",
  spouse: "Spouse or Partner",
};

const CARE_OPTION_LABELS: Record<CareOptionKey, string> = {
  everydayTasks: "Everyday Tasks",
  memoryCare: "Memory Care",
  mobilityAssistance: "Mobility Assistance",
  other: "Other",
};

const URGENCY_OPTIONS: readonly UrgencyOption[] = [
  { label: "Right away", value: "right-away" },
  { label: "Within a few weeks", value: "within-a-few-weeks" },
  { label: "Just planning ahead", value: "just-planning-ahead" },
  { label: "I'm not sure", value: "not-sure" },
];

function getCareRecipientLabel(recipient: CareRecipient): string {
  return CARE_RECIPIENT_LABELS[recipient];
}

function getCareOptionLabel(option: CareOptionKey): string {
  return CARE_OPTION_LABELS[option];
}

function getUrgencyLabel(value: string): string {
  const option = URGENCY_OPTIONS.find((option) => option.value === value);
  return option?.label ?? value;
}

export {
  CARE_OPTION_LABELS,
  CARE_RECIPIENT_LABELS,
  getCareOptionLabel,
  getCareRecipientLabel,
  getUrgencyLabel,
  URGENCY_OPTIONS,
};
